(function (angular) {
    "use strict";
    var fmgApp = angular.module('FmgProduceSuite-Launcher');

    fmgApp.controller('LoginController', function ($scope, authenticationService, $stateParams, $state, screenBlockService,Analytics,tenantSetupService) {

        $scope.user = {};

        $scope.OnInit = function(){
            if(authenticationService.isLoggedIn()){
                $state.go('list');
            }

            tenantSetupService.getSettings().then(function(response){
              if(response.data.TenantId === 1 && response.data.AuthenticationRelay){
                  $scope.isDomainLoginActivated = true;
              }
            })
        };

        var onLogin = function(forcePasswordReset,resetToken){
            screenBlockService.clearScreen();

            if (authenticationService.isLoggedIn()) {

                $scope.user.failedLogin = false;

                if (forcePasswordReset === true) {

                    $state.go('set', {
                        code: resetToken
                    });
                }
                else {

                    $state.go('list');

                    //var targetState = 'default';
                    //var params = null;
                    //if ($stateParams.redirectTo) {
                    //
                    //    params = $stateParams.redirectToParams;
                    //    targetState = $stateParams.redirectTo;
                    //}
                    //
                    //if (!params || params === null) {
                    //    $state.go(targetState);
                    //} else {
                    //    $state.go(targetState, JSON.parse(params));
                    //}
                }
            }
        };

        var onFailedLogin = function(wasConnectionError){

            screenBlockService.clearScreen();

            $scope.user.failedLogin = true;

        };


        $scope.signin = function(loginForm) {

            //Cat, action, opt_label, opt_value, opt_non_interaction
            Analytics.trackEvent('loginAttempt', $scope.user.username);

            if(loginForm.$valid) {
                screenBlockService.blockScreen();

                authenticationService.login($scope.user, onLogin,onFailedLogin);
            }
        };

        $scope.ntlmLogin = function(){
            authenticationService.ntlmLogin(onLogin,onFailedLogin)
        };

        $scope.logout = function(){
            authenticationService.logout();
        };

    });
}) ( window.angular );